import React from "react";
import { Modal } from "antd";

export const ListingModalContentComponent = (props) => {
  const { visible, onOk, content = null } = props;

  return (
    <>
      <Modal
        title="View Asset"
        visible={visible}
        onOk={onOk}
        onCancel={onOk}
        width="80%"
        centered={false}
        closable={true}
      >
        {content}
      </Modal>
    </>
  );
};
